import { Skeleton } from "../skeleton";
import { TableCell, TableRow } from "../table";

type Props = {
  col?: number;
  row?: number;
};
const TableRowSkeleton = ({ col = 2, row = 3 }: Props) => {
  return (
    <>
      {Array.from({ length: row }).map((_, index) => (
        <TableRow key={index}>
          {Array.from({ length: col }).map((_, index) => (
            <TableCell key={index}>
              <Skeleton className="mx-2 h-5" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default TableRowSkeleton;
